import React from "react";
import "../../css/Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <p className="footer-text">© 2025 Morris y Luna. Todos los derechos reservados.</p>
                <div className="footer-links">
                    <Link to="/acerca">Nosotros</Link>
                    <Link to="/contacto">Contacto</Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
